import styled from "styled-components";

export const Container = styled.div`
  background-color: #fff;
  border-radius: 100%;
  color: ${({ theme }) => theme.colors.primaryBlue.main} !important;
  font-size: 12pt;
  width: 1.8rem;
  height: 1.8rem;
  text-align: center;
  line-height: 2rem;
  &:hover {
    cursor: pointer;
  }
`;

export const HelpMenuBar = styled.div`
  position: relative;
`;

export const MenuContainer = styled.nav`
  background-color: #fff;
  color: #000;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  min-width: 14rem;
  position: absolute;
  margin-top: .8rem;
  z-index: 30;
  border: 1px solid #efefef;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  right: -1rem;

`;

export const ListItens = styled.ul`
  color: ${({ theme }) => theme.colors.primaryBlue.main} !important;
  padding: 0px !important;
  margin: 0px !important;
`;

export const Item = styled.li`
  color: ${({ theme }) => theme.colors.primaryBlue.main} !important;
  list-style: none;
  padding: 8px;
`;

export const ItemLink = styled.button`
  background-color: transparent;
  border: none;
  padding: 0px;
  margin: 0px;
`;

export const Wrapper = styled.div``;
